import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { Loader2, CheckCircle2, AlertCircle } from "lucide-react";

export default function PaymentSuccessPage() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("checking"); // checking | paid | timeout | error

  useEffect(() => {
    if (!sessionId) { setState("error"); return; }
    let tries = 0;
    let active = true;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setState("paid"); setTimeout(() => { window.location.href = "/"; }, 1800); return; }
      } catch (e) { /* keep polling */ }
      tries += 1;
      if (tries >= 8) { setState("timeout"); return; }
      if (active) setTimeout(poll, 2000);
    };
    poll();
    return () => { active = false; };
  }, [sessionId]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6" data-testid="payment-success-page">
      <div className="text-center max-w-md">
        {state === "checking" && (<><Loader2 className="w-10 h-10 klt-spin mx-auto text-primary" /><h1 className="font-heading text-xl font-bold mt-4">Confirmation du paiement…</h1><p className="text-sm text-muted-foreground mt-1">Un instant, nous activons votre abonnement.</p></>)}
        {state === "paid" && (<><CheckCircle2 className="w-12 h-12 mx-auto text-green-500" /><h1 className="font-heading text-2xl font-bold mt-4" data-testid="payment-success-title">Abonnement activé 🎉</h1><p className="text-sm text-muted-foreground mt-1">Redirection vers l'application…</p></>)}
        {state === "timeout" && (<><AlertCircle className="w-10 h-10 mx-auto text-amber-500" /><h1 className="font-heading text-xl font-bold mt-4">Paiement en cours de traitement</h1><p className="text-sm text-muted-foreground mt-1">Cela peut prendre quelques instants. <a href="/" className="text-primary underline">Retour à l'application</a></p></>)}
        {state === "error" && (<><AlertCircle className="w-10 h-10 mx-auto text-red-500" /><h1 className="font-heading text-xl font-bold mt-4">Session introuvable</h1><p className="text-sm text-muted-foreground mt-1"><a href="/abonnement" className="text-primary underline">Revoir les offres</a></p></>)}
      </div>
    </div>
  );
}
